const CardComment = ({ name, ponsition, content, cardIndex }) => {
  return (
    <div
      className={`p-4 h-[300px] flex flex-col justify-between rounded-xl shadow-blue-500  hover:shadow-2xl transition-all duration-300 cursor-pointer ${
        cardIndex % 2 !== 0
          ? "bg-primary_light text-white"
          : "border-[2px] border-primary border-opacity text-primary bg-white"
      }`}
    >
      <div className="">
        <p className="text-[1.5rem]">{content}</p>
      </div>
      <div className="">
        <p className=" ">{name}</p>
        <p className="">{ponsition}</p>
      </div>
    </div>
  );
};

export default CardComment;
